import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import BaseLayout from "./components/Layouts/BaseLayout";
import WebBaseLayout from "./components/weblayouts/WebBaseLayout";
import DashboardPage from "./Pages/Admin/Dashboard";
import ForgotPasswordPage from "./Pages/Admin/Auth/ForgotPassword";
import PasswordChangePage from "./Pages/Admin/Auth/ChangePassword";
import MemberProfilePage from "./Pages/Member/Profile";
import AdminDashboard from "./Pages/Admin/Dashboard";
import VerifyEmailPage from "./Pages/Admin/Auth/VerifyEmail";
import EmailVerifiedPage from "./Pages/Admin/Auth/EmailVerified";
import AdminLoginPage from "./Pages/Admin/Auth/Login";
import UserManagement from "./Pages/Admin/User/UserManagement";
import ManageCustomer from "./Pages/Admin/CustomerManagement/ManageCustomer";
import Product from "./Pages/Admin/ProductManagement/Product";
import ManageOrder from "./Pages/Admin/OrderManagement/ManageOrder";
import CheckinPage from "./Pages/Admin/InventoryManagement/Check-In";
import CreditPgae from "./Pages/Admin/CreditManagement/CreditPage";
import CategoryManager from "./Pages/Admin/CategoryManager/Index";
import ManageAcl from "./Pages/Admin/User/ManageAcl";
import ProtectedRoute from "./hooks/protectedRoute";
import Forbidden from "./Pages/Admin/Forbidden";
import NotFoundPage from "./Pages/Admin/NotFoundPage";
import ManageCustomerCompany from "./Pages/Admin/CustomerManagement/ManaCustomerCompany";
import TransferPage from "./Pages/Admin/InventoryManagement/Transfer";
import GroupAndSimpleCode from "./Pages/Admin/ProductManagement/GroupAndSimpleCode";
import Index from "./Pages/Admin/AccountNumber/Index";
import OrderApproval from "./Pages/Admin/OrderManagement/OrderApproval";
import ManageCheckout from "./Pages/Admin/RequisitManagement/ManageCheckout";
import Payment from "./Pages/Admin/PaymentApproval/Payment";
import ManageWarehouse from "./Pages/Admin/InventoryManagement/ManageWarehouse";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/auth/login" />} />
      <Route path="auth">
        <Route path="login" element={<AdminLoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<PasswordChangePage />} />
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="email-verified" element={<EmailVerifiedPage />} />
      </Route>
      <Route path="app">
        <Route
          path="dashboard"
          element={
            <ProtectedRoute
              element={DashboardPage}
              layout={BaseLayout}
              permission="view_dashboard"
            />
          }
        />
        <Route
          path="profile"
          element={
            <ProtectedRoute
              element={MemberProfilePage}
              layout={BaseLayout}
              permission="roles_and_permissions"
            />
          }
        />
        <Route
          path="acl"
          element={
            <ProtectedRoute
              element={ManageAcl}
              layout={BaseLayout}
              permission="roles_and_permissions"
            />
          }
        />
        <Route
          path="user-management"
          element={
            <ProtectedRoute
              element={UserManagement}
              layout={BaseLayout}
              permission="view_user"
            />
          }
        />
        <Route
          path="customer"
          element={
            <ProtectedRoute
              element={ManageCustomer}
              layout={BaseLayout}
              permission="view_customer"
            />
          }
        />
        <Route
          path="company_details"
          element={
            <ProtectedRoute
              element={ManageCustomerCompany}
              layout={BaseLayout}
            />
          }
        />
        <Route
          path="product-management"
          element={
            <ProtectedRoute
              element={Product}
              layout={BaseLayout}
              permission="view_product"
            />
          }
        />
        <Route
          path="group-simplecode"
          element={
            <ProtectedRoute
              element={GroupAndSimpleCode}
              layout={BaseLayout}
              permission="view_product"
            />
          }
        />

        <Route
          path="bank-accounts"
          element={
            <ProtectedRoute
              element={Index}
              layout={BaseLayout}
              permission="view_product"
            />
          }
        />

        <Route
          path="order-management"
          element={
            <ProtectedRoute
              element={ManageOrder}
              layout={BaseLayout}
              permission="view_order"
            />
          }
        />
        <Route
          path="order-approval"
          element={
            <ProtectedRoute
              element={OrderApproval}
              layout={BaseLayout}
              permission="approve_order"
            />
          }
        />
        <Route
          path="check-in"
          element={
            <ProtectedRoute
              element={CheckinPage}
              layout={BaseLayout}
              permission="view_inventory"
            />
          }
        />
        <Route
          path="check-out"
          element={
            <ProtectedRoute
              element={ManageCheckout}
              layout={BaseLayout}
              permission="view_inventory"
            />
          }
        />
        <Route
          path="transfer"
          element={
            <ProtectedRoute
              element={TransferPage}
              layout={BaseLayout}
              permission="view_inventory"
            />
          }
        />
        <Route
          path="manage-warehouse"
          element={
            <ProtectedRoute
              element={ManageWarehouse}
              layout={BaseLayout}
              permission="view_inventory"
            />
          }
        />
        <Route
          path="credit"
          element={<ProtectedRoute element={CreditPgae} layout={BaseLayout} />}
        />
        <Route
          path="manage-category"
          element={
            <ProtectedRoute
              element={CategoryManager}
              layout={BaseLayout}
              permission="view_product"
            />
          }
        />
        <Route
          path="payment"
          element={
            <ProtectedRoute
              element={Payment}
              layout={BaseLayout}
              permission="view_product"
            />
          }
        />
      </Route>
      <Route
        path="app/dashboard"
        element={
          <WebBaseLayout>
            <AdminDashboard />
          </WebBaseLayout>
        }
      />
      <Route path="/unauthorized" element={<Forbidden />} />
      <Route path="*" element={<NotFoundPage />} />{" "}
      {/* Catch-all route for 404 */}
    </Routes>
  );
};

export default AppRoutes;
